import { render, staticRenderFns } from "./addPermissions.vue?vue&type=template&id=404a9700&"
import script from "./addPermissions.vue?vue&type=script&lang=js&"
export * from "./addPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports